export class HomeModel {
    id:number;
    menuId:number;
    bottomText: string;
    selfServe:string;
    bottomSectionLeftText: string;
    bottomSectionMidText:string;
    bottomSectionRightText: string;
    leftTopBanner: string;
    rightTopBanner:string;
}
